import { render } from "./TranscoderDashboard.vue?vue&type=template&id=10e23b5e"
import script from "./TranscoderDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./TranscoderDashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/TranscoderDash/TranscoderDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10e23b5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10e23b5e', __exports__)) {
    api.reload('10e23b5e', __exports__)
  }
  
  module.hot.accept("./TranscoderDashboard.vue?vue&type=template&id=10e23b5e", () => {
    api.rerender('10e23b5e', render)
  })

}


export default __exports__